import { useMemo, useEffect, useState } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Grid } from "@mui/material";
import DataPointWidget from "components/LH/HC/Panchangaya";

function PlanetInfopPop({ data, title }) {
    return (
        <MDBox pt={0} pb={1} xs={12}>
            <MDBox mb={1}>
                <Card>
                    <MDBox p={3} lineHeight={1} mb={0}>
                        <MDTypography variant="h5" fontWeight="medium">
                            {title}
                        </MDTypography>
                    </MDBox>
                    <hr />
                    <Grid container mt={1} ml={0} pl={1} spacing={4}>
                        {data.map((item, index) => (
                            <Grid key={"s3" + index} item style={{ paddingTop: 4, paddingLeft: 4, marginBottom: 8 }} xs={6}>
                                <DataPointWidget name={item.name} value={item.value} />
                            </Grid>
                        ))}
                    </Grid>
                </Card>
            </MDBox>
        </MDBox>
    );
};

PlanetInfopPop.propTypes = {
    data: PropTypes.array,
    title: PropTypes.string
};

export default PlanetInfopPop;